buyBonusPopup = {};
buyBonusPopup.open = false;

////////////////////////////////////////////////////////
buyBonusPopup.show = function (callback) {
  buyBonusPopup.open = true;
  soundManager.play("buyBonusClick");
  buyBonusPopup.fireballSelected = false;
  buyBonusPopup.buyBonusHigh = false;

  buyBonusPopup.fireballButton.enableButton(true);
  buyBonusPopup.freeSpinsButton.enableButton(true);

  buyBonusPopup.closeButton.enableButton(true);
  //buyBonusPopup.infoButton.enableButton(true);

  const goldenBetButton = resourceManager.get("goldenBetToggleButton");
  if (goldenBetButton) {
    goldenBetButton.enterBuyABonus();
  }
  //encoreButton.cancelEncore();
  messageBus.post("game:modal", { reason: "buy_bonus" });

  const fireballStakes =
    buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.coinSizes;
  const freeSpinsStakes =
    buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_HIGH.coinSizes;

  // combine all the stakes and remove duplicates - then sort
  // this might all go wrong with stake indexes as some stakes will only be in one mode and not the other
  buyBonusPopup.allStakesCombined = fireballStakes.concat(
    freeSpinsStakes.filter(function (el) {
      return freeSpinsStakes.indexOf(el) === -1;
    })
  );
  buyBonusPopup.allStakesCombined.sort(function (a, b) {
    return a - b;
  });

  // if the buy a bonus default stakes are different we choose the lowest of the two - game design
  const fireBallDefault =
    buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW
      .defaultAmountPerLine;
  const fsDefault =
    buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_HIGH
      .defaultAmountPerLine;

  let defaultToUse = fireBallDefault;

  if (fireBallDefault !== fsDefault) {
    console.log("WARNING: Default buy a bonus stakes differ between modes");
    defaultToUse = Math.min(fireBallDefault, fsDefault);
  }

  let defaultIndex = buyBonusPopup.allStakesCombined.indexOf(defaultToUse);
  buyBonusPopup.combinedStakeIndex = defaultIndex;

  buyBonusPopup.updatePopup();

  resourceManager.getContainer("buyABonusContainer").visible = true;
  buyBonusPopup.container.visible = true;
  buyBonusPopup.callback = callback;
};

////////////////////////////////////////////////////////
buyBonusPopup.updatePopup = function () {
  if (buyBonusPopup.combinedStakeIndex === -1) {
    // Something went really wrong here. No compatible stakes found
    buyBonusPopup.stakePreviousButton.enableButton(false);
    buyBonusPopup.stakeNextButton.enableButton(false);
    buyBonusPopup.fireballButton.enableButton(false);
    buyBonusPopup.freeSpinsButton.enableButton(false);
  } else {
    const bonusBuyStakes = buyBonusPopup.allStakesCombined;

    // update the stake buttons
    buyBonusPopup.stakePreviousButton.enableButton(
      buyBonusPopup.combinedStakeIndex > 0
    );
    buyBonusPopup.stakeNextButton.enableButton(
      buyBonusPopup.combinedStakeIndex < bonusBuyStakes.length - 1
    );

    // update the base stake box
    let baseStake = buyBonusPopup.convertToTotalStake(
      bonusBuyStakes[buyBonusPopup.combinedStakeIndex]
    );
    buyBonusPopup.baseStakeText.setText(gdk.formatCurrency(baseStake));

    // check stake is valid for each buy a bonus mode
    const fireballStakes =
      buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW
        .coinSizes;
    const freeSpinsStakes =
      buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_HIGH
        .coinSizes;
    const stakeToFind = bonusBuyStakes[buyBonusPopup.combinedStakeIndex];

    let fireballStakeExists = fireballStakes.includes(stakeToFind);
    let freeSpinsStakeExists = freeSpinsStakes.includes(stakeToFind);

    // Fireball link costs
    let costFireball =
      baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFireball;
    buyBonusPopup.fireballLinkCostValue.setText(
      gdk.formatCurrency(costFireball)
    );
    buyBonusPopup.fireballButton.enableButton(
      buyBonusPopup.balance >= costFireball && fireballStakeExists
    );

    // Free spins costs
    let costFreeSpins =
      baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpins;
    buyBonusPopup.freeSpinsCostValue.setText(gdk.formatCurrency(costFreeSpins));
    buyBonusPopup.freeSpinsButton.enableButton(
      buyBonusPopup.balance >= costFreeSpins && freeSpinsStakeExists
    );
  }
};

////////////////////////////////////////////////////////
buyBonusPopup.create = function (json) {
  return new PIXI.Container();
};

////////////////////////////////////////////////////////
buyBonusPopup.convertToTotalStake = function (coinSize) {
  const stakeController = resourceManager.getController("stakeController");
  const numLines = stakeController.CurrentWinLineCount;

  return coinSize * numLines;
};

////////////////////////////////////////////////////////
buyBonusPopup.onStakeNextPressed = function () {
  soundManager.play("buyBonusInc");

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  buyBonusPopup.combinedStakeIndex = Math.min(
    buyBonusPopup.combinedStakeIndex + 1,
    bonusBuyStakes.length - 1
  );
  buyBonusPopup.updatePopup();
};

////////////////////////////////////////////////////////
buyBonusPopup.onStakePreviousPressed = function () {
  soundManager.play("buyBonusDec");

  buyBonusPopup.combinedStakeIndex = Math.max(
    buyBonusPopup.combinedStakeIndex - 1,
    0
  );
  buyBonusPopup.updatePopup();
};

////////////////////////////////////////////////////////
buyBonusPopup.initialise = function (json, container) {
  buyBonusPopup.container = container;
  buyBonusPopup.container.visible = false;

  buyBonusPopup.fadedMask = new PIXI.Graphics();
  buyBonusPopup.fadedMask.beginFill(0, 0.8);
  buyBonusPopup.fadedMask.drawRect(-10000, -10000, 20000, 20000);
  buyBonusPopup.fadedMask.endFill();
  buyBonusPopup.container.addChild(buyBonusPopup.fadedMask);
  messageBus.subscribe("spinner:GameConfigEvent", buyBonusPopup.onGameConfig);
  messageBus.subscribe("common:BalanceEvent", buyBonusPopup.onBalanceEvent);
  messageBus.subscribe("game:modal", buyBonusPopup.onModal);

  buyBonusPopup.helpActive = false;
};

////////////////////////////////////////////////////////
buyBonusPopup.onModal = function (data) {
  if (buyBonusPopup.container.visible) {
    if (data.reason && data.reason === "Options menu open") {
      buyBonusPopup.helpActive = true;

      buyBonusPopup.fireballButton.enableButton(false);
      buyBonusPopup.freeSpinsButton.enableButton(false);
      buyBonusPopup.closeButton.enableButton(false);
      //buyBonusPopup.infoButton.enableButton(false);

      // update the stake buttons
      buyBonusPopup.stakePreviousButton.enableButton(false);
      buyBonusPopup.stakeNextButton.enableButton(false);
    } else if (buyBonusPopup.helpActive) {
      buyBonusPopup.helpActive = false;

      buyBonusPopup.fireballButton.enableButton(true);
      buyBonusPopup.freeSpinsButton.enableButton(true);
      buyBonusPopup.closeButton.enableButton(true);
      //buyBonusPopup.infoButton.enableButton(true);

      buyBonusPopup.updatePopup();
    }

    if (buyBonusPopup.open) {
      if (data.reason === undefined) {
        messageBus.post("game:modal", { reason: "buy_bonus" });
      }
    }
  }
};

////////////////////////////////////////////////////////
buyBonusPopup.init = function () {
  buyBonusPopup.background = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground"
  );

  buyBonusPopup.fireballButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:leftOptionPanel:fireballButton"
  );

  buyBonusPopup.fireballButton.onPressedCallback = buyBonusPopup.onClickedYes;

  buyBonusPopup.freeSpinsButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:rightOptionPanel:freeSpinsButton"
  );
  buyBonusPopup.freeSpinsButton.onPressedCallback =
    buyBonusPopup.onClickedFreeSpins;

  buyBonusPopup.closeButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:closeButton"
  );
  buyBonusPopup.closeButton.onPressedCallback = buyBonusPopup.onClickedNo;

  // buyBonusPopup.infoButton = resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:infoButton");
  // buyBonusPopup.infoButton.onPressedCallback = buyBonusPopup.onInfo;

  buyBonusPopup.stakePreviousButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:stakePrevious"
  );
  buyBonusPopup.stakePreviousButton.onPressedCallback =
    buyBonusPopup.onStakePreviousPressed;

  buyBonusPopup.stakeNextButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:stakeNext"
  );
  buyBonusPopup.stakeNextButton.onPressedCallback =
    buyBonusPopup.onStakeNextPressed;

  buyBonusPopup.baseStakeText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:baseStakeText"
  );

  buyBonusPopup.fireballLinkCostValue = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:leftOptionPanel:fireballLinkCostValue"
  );
  buyBonusPopup.freeSpinsCostValue = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:rightOptionPanel:freeSpinsCostValue"
  );
};

////////////////////////////////////////////////////////
buyBonusPopup.onGameConfig = function (event) {
  buyBonusPopup.gameConfig = event;
  buyBonusPopup.init();
};

////////////////////////////////////////////////////////
buyBonusPopup.onBalanceEvent = function (event) {
  buyBonusPopup.balance = event.data.balance;
};

////////////////////////////////////////////////////////
buyBonusPopup.onClosePopup = function (buyBonus) {
  buyBonusPopup.open = false;

  if (buyBonus) {
    buyBonusPopup.onStartBonusSpin();
  } else {
    soundManager.play("buyBonusCancel");
    messageBus.post("game:modal", {});
  }

  let reels = resourceManager.get("slotContainer:reelContainer");
  reels.alpha = 1.0;

  buyBonusPopup.container.visible = false;
  buyBonusPopup.callback(buyBonus);
};

////////////////////////////////////////////////////////
buyBonusPopup.onStartBonusSpin = function () {
  gameController.inBuyABonus = true;
  gameController.buyABonusHigh = !buyBonusPopup.fireballSelected;

  gameData.winningsMeter.set(0);

  messageBus.post("game:modal", {});

  let stakeController = resourceManager.getController("stakeController");
  const numLines = stakeController.CurrentWinLineCount;

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;

  let baseStake = buyBonusPopup.convertToTotalStake(
    bonusBuyStakes[buyBonusPopup.combinedStakeIndex]
  );

  let stakes = stakeController.Stakes;
  let returnStake = stakes.find((stake) => stake === baseStake);

  if (!returnStake) {
    returnStake = stakes[0];
  }

  stakeController.requestChangeStake(returnStake);

  stakeController.requestChangeStake(baseStake, "BONUS_BUY_LOW");

  stakeController.requestChangeStake(baseStake, "BONUS_BUY_HIGH");

  const bpl = baseStake / numLines;
  const buyCost = buyBonusPopup.fireballSelected
    ? buyBonusPopup.gameConfig.data.buyBonusCostFireball
    : buyBonusPopup.gameConfig.data.buyBonusCostFreeSpins;

  gameController.initNewGame();

  gdk.startGame(
    {
      /////////////////////
      stake: baseStake * buyCost,
      numWinlines: numLines,
      bpl: bpl,
      metaData: {
        encore: false,
        buyABonus: true,
        buyBonusHighActive: buyBonusPopup.buyBonusHigh,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

////////////////////////////////////////////////////////
buyBonusPopup.onClickedYes = function () {
  buyBonusPopup.fireballSelected = true;
  buyBonusPopup.buyBonusHigh = false;

  buyBonusPopup.onClosePopup(true);
};

////////////////////////////////////////////////////////
buyBonusPopup.onClickedFreeSpins = function () {
  buyBonusPopup.fireballSelected = false;
  buyBonusPopup.buyBonusHigh = true;

  buyBonusPopup.onClosePopup(true);
};

////////////////////////////////////////////////////////
buyBonusPopup.onClickedNo = function () {
  buyBonusPopup.open = false;
  messageBus.post("game:modal", {});
  buyBonusPopup.onClosePopup(false);
};

////////////////////////////////////////////////////////
buyBonusPopup.onInfo = function () {
  soundManager.play("buttonPressed");
  gameData.helpPageScroll.open();
};

////////////////////////////////////////////////////////
buyBonusPopup.getFilesRequired = function (json) {
  return [];
};

////////////////////////////////////////////////////////
resourceManager.registerObjectType(
  "buyBonusPopup",
  buyBonusPopup.create,
  buyBonusPopup.initialise,
  buyBonusPopup.getFilesRequired
);
